import IssuerListContainer from '../helpers/IssuerListContainer';

class MolPayEbankingVNElement extends IssuerListContainer {
    public static type = 'molpay_ebanking_VN';
}

export default MolPayEbankingVNElement;
